import * as types from '../mutation-types'
import VueJwtDecode from 'vue-jwt-decode'
const state = {
  main: {
    name: 'Alexander Pierce',
    position: 'Web Developer',
    authorized: false ,
    token:'',
    location:{country:'',state:'',district:'',city_union:''},
    state: {
      color: '#3c763d',
      name: 'Online'
    },
    createdAt: new Date()
  },
  error:{}
}

const mutations = {
   [types.LOGIN] (state, data) {
    const decode = VueJwtDecode.decode(data.accessToken) 
    // console.log('JWT-----VVVVV')
   //  console.log(decode)
    const main2 = {
      name: decode.name,
      contactNumber: decode.contactNumber,
      position: decode.permissionLevel,
      authorized: true ,
      token: data.accessToken,
      location:{country:decode.country,state:decode.state,district:decode.district,city_union:decode.city_union,coordinates:decode.location.coordinates},
      state: {
        color: '#3c763d',
        name: 'Online'
      },
      createdAt: new Date()
    }
    localStorage.setItem('users', JSON.stringify(main2))
    state.main = main2
  },
  [types.ERROR] (state, data) {
    state.error = data
  },
  [types.LOGOUT] (state) {
    const main2 = {
      name: 'guest',
      position: '',
      contactNumber: '',
      authorized: false ,
      token: '',
      location:{country:'',state:'',district:'',city_union:''},
      state: {
        color: '#ff1100',
        name: 'Offline'
      },
      createdAt: new Date()
    }
    localStorage.removeItem('users')
    state.main = main2
  },
  [types.LOGIN_STATUS] (state) {
    const main2 = {
      name: 'guest',
      position: '',
      authorized: false ,
      contactNumber: '',
      token: '',
      location:{country:'',state:'',district:'',city_union:''},
      state: {
        color: '#ff1100',
        name: 'Offline'
      },
      createdAt: new Date()
    }
    const localData = localStorage.getItem('users')
    const jsonData = localData ? JSON.parse( localData ) : main2
    state.main = jsonData
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js